const setState = (trigger: HTMLElement, state: 'expanded' | 'collapsed'): void => {
  trigger.dataset.state = state;

  if (!trigger.dataset.target) {
    throw new Error('Collapsible trigger has no target');
  }

  const selector = trigger.dataset.target;
  const targets = document.querySelectorAll<HTMLElement>(selector);

  if (targets.length === 0) {
    throw new Error('Collapsible trigger has no target');
  }
  targets.forEach((target) => {
    target.dataset.state = state;
  });
};

const setInitialStates = (trigger: HTMLElement): void => {
  const state = trigger.dataset.state === 'expanded' ? 'expanded' : 'collapsed';
  setState(trigger, state);
};

const toggleStates = (trigger: HTMLElement): void => {
  const state = trigger.dataset.state === 'expanded' ? 'collapsed' : 'expanded';
  setState(trigger, state);
};

export const initCollapsible = (trigger: HTMLElement): void => {
  setInitialStates(trigger);
  trigger.addEventListener('click', (e) => {
    toggleStates(trigger);
    e.preventDefault();
  });
};

export const initCollapsibles = (): void => {
  const selector = '[data-toggle="collapse"]';
  const collapsibles = document.querySelectorAll<HTMLElement>(selector);
  collapsibles.forEach(initCollapsible);
};
